import { NewPeriod } from '@app/models/period';
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';

type PeriodContextType = {
  selectedPeriod: NewPeriod | undefined;
  setSelectedPeriod: Dispatch<SetStateAction<NewPeriod | undefined>>;
};

const PeriodContext = createContext<PeriodContextType | undefined>(undefined);

export function PeriodProvider({ children }: { children: React.ReactNode }) {
  const [selectedPeriod, setSelectedPeriod] = useState<NewPeriod | undefined>(undefined);

  const contextValue = useMemo(() => ({ selectedPeriod, setSelectedPeriod }), [selectedPeriod]);

  return <PeriodContext.Provider value={contextValue}>{children}</PeriodContext.Provider>;
}

export const usePeriod = () => {
  const context = useContext(PeriodContext);
  if (!context) {
    throw new Error('usePeriod must be used within a PeriodProvider');
  }
  return context;
};
